import "./theme-card";

import { Storybook } from "@tento-ui/ui/storybook";
import { MoonFillIcon, LonaIcons } from "@tento-ui/ui/icons";
import { NuxThemeCard } from "./theme-card";
import { $makeHomeCard } from "@tento-ui/components/home-card/home-grid-card.example";
import {
  Appearance,
  DebounceExecutors,
  LonaSdk,
  RequestErrorHandlers,
  MemoryStorage,
} from "@tento-lona";
import { DOM_DEBOUNCE_BRIDGE, DOM_HOST } from "@tento-lona/sheets-ui";
import { InvalidationSink, SheetRegistries } from "@tento-lona/sheets";

const storyClient = new LonaSdk.Client({
  storage: new MemoryStorage(),
  host: DOM_HOST,
  registries: SheetRegistries.BUILTINS,
  invalidation: InvalidationSink.create(),
  onSheetPromoted: null,
  baseUrl: null,
  accessToken: null,
  fetch: null,
  rowsOptions: (client) => ({
    backend: client.httpBackend(),
    calendarConfig: LonaSdk.Client.EMPTY_CALENDAR_CONFIG,
    taskListConfig: LonaSdk.Client.EMPTY_TASK_LIST_CONFIG,
    calendarPrefs: null,
  }),
  requestErrorHandler: RequestErrorHandlers.TRACE,
  debounceExecutor: DebounceExecutors.browser(DOM_DEBOUNCE_BRIDGE),
  appearance: Appearance.HEADLESS,
});

export class NuxThemeCardStoryBook extends Storybook.Default {
  title(): string {
    return "Nux Theme Card";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "In Context",
        render: () =>
          $makeHomeCard({
            title: "Pick a theme",
            icon: LonaIcons.$template(MoonFillIcon),
            contentBg: "var(--bg-surface-light-opaque)",
            $cardContent: NuxThemeCard.makeWith(storyClient.themes),
          }),
      },
      {
        title: "Raw",
        render: () => NuxThemeCard.makeWith(storyClient.themes),
      },
    ];
  }
}
